import { defineComponent as _defineComponent } from 'vue'
import { date } from '@/admin-shared-modules/utils/format'
import { onMounted } from 'vue'
import { useRouter } from 'vue-router/composables'
import { DevicesOfTemplate } from '../template-edit/store'
import { store } from './store'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()

const list = store.list
const search = store.search

onMounted(() => {
  store.list.fetch()
})

return { __sfc: true,router, list, search, date, DevicesOfTemplate, store }
}

})